@if(viewModel$ | async; as vm){
<lay-panel>
  <lay-panel-content>
    <lay-panel-block size="fluid" class="users-image is-borderless is-paddingless" />
    <lay-panel-block class="has-gradient is-justify-center share-title" size="fluid" styleClass="is-borderless">
      <app-text class="text-18 text-align-center is-family-bold" [text]="'settings.__SHARE_HOME_TITLE' | LANG" />
    </lay-panel-block>

    <lay-panel-block size="fluid" styleClass="side-borderless">
      <app-text class="is-family-regular" [text]="'settings.__FULL_ACCESS' | LANG" />
    </lay-panel-block>

    @for(user of vm.users; track user){
    <lay-panel-block size="default" class="is-space-between" styleClass="side-borderless">
      <div class="is-flex gap-16 items-align-center">
        <el-email-badge color="primary-background" [text]="user.name" />
        <app-text [text]="user.name" class="is-family-regular" />
      </div>
      <div class="is-flex gap-8">
        @if (user.is_caller) {
        <app-text class="has-margin-centered current-user-indicator has-text-primary is-family-medium"
          [text]="'(' + ('common-settings.__USER_ME' | LANG) + ')'" />
        }
        @if(vm.users.length > 1) {
        <app-icon name="velux-delete-24" class="is-align-end is-cursor-pointer has-text-grey-dark is-size-4"
          (click)="removeUser(user)" />
        }
      </div>
    </lay-panel-block>
    }
    <!-- For hovering button -->
    <lay-panel-block size="large" transparent="true" />
  </lay-panel-content>

  <lay-panel-footer styleClass="is-floating">
    <lay-button class="is-flex-button">
      <button [share] [shareAsync]="homeInvite$" (hasShared)="hasCopied($event)" (click)="copied.next(null)" [ngClass]="{
            'has-shared': vm.hasCopied,
            'is-loading': vm.hasCopied === null
          }">
        @if (vm.hasCopied) {
        <app-icon class="is-size-4" [name]="'check'" />
        }
        <app-text class="is-family-bold"
          [text]="vm.hasCopied ? ('common-settings.__LINK_COPIED' | LANG) : ('common-settings.__ADD_USER' | LANG)" />
      </button>
    </lay-button>
  </lay-panel-footer>
</lay-panel>
<!-- Confirm modal -->
<app-modal [display]="removeUserModalDisplay()">
  <app-modal-header class="gap-8">
    <app-icon name="velux-generic-error-32" class="text-red-alert text-32" />
    <app-text class="is-family-bold"
      [text]="'common-settings.__B2B_DISSOCIATE_OTHERS_TITLE' | LANG" />
  </app-modal-header>
  <app-modal-body class="items-align-center gap-16">
    <app-text class="text-14 text-grey-120" [text]="setConfirmText(vm.selectedUser)" />
    <lay-button class="is-flex-button">
      <button [ngClass]="{ 'is-loading': isLoading()}"
        (click)="removeUserFromHome(vm.homeId, vm.selectedUser)" type="submit">
        <app-text class="is-family-bold" [text]="'common-settings.__DISSOCIATE_APP' | LANG" />
      </button>
    </lay-button>
  </app-modal-body>

  <app-modal-footer (click)="removeUserModalDisplay.set(false)">
    <app-text [text]="'common-settings.__CANCEL' | LANG" class="is-family-bold text-grey-120 is-cursor-pointer" />
  </app-modal-footer>
</app-modal>
}
